import { Play } from "lucide-react";

function TrackList({ tracks, showPlays = true, onOpenDetails, onPlayTrack }) {
  return (
    <div className="track-list">
      {tracks.map((track, index) => (
        <div
          key={track.id || track.title}
          className={`track-row${track.isUnavailable ? " is-unavailable" : ""}`}
          role={onOpenDetails ? "button" : undefined}
          tabIndex={onOpenDetails ? 0 : undefined}
          onClick={() => onOpenDetails?.(track)}
          onKeyDown={(event) => {
            if (!onOpenDetails) return;
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onOpenDetails(track);
            }
          }}
        >
          <div className="track-meta">
            <span className="track-index">{index + 1}</span>
            <div>
              <p className="track-title">{track.title}</p>
              <p className={`track-artist${track.isUnavailable ? " is-warning" : ""}`}>
                {track.isUnavailable
                  ? track.unavailableText || "Not available in your country"
                  : track.artist}
              </p>
            </div>
          </div>

          {showPlays ? (
            <p className="track-plays">{track.isUnavailable ? "-" : track.plays || track.album}</p>
          ) : (
            <p className="track-plays">{track.eta}</p>
          )}
          <div className="track-actions">
            {onPlayTrack ? (
              <button
                type="button"
                className="track-play-btn"
                aria-label={track.isUnavailable ? `${track.title} is unavailable` : `Play ${track.title}`}
                disabled={track.isUnavailable}
                onClick={(event) => {
                  event.stopPropagation();
                  onPlayTrack(track, index);
                }}
              >
                <Play size={14} />
              </button>
            ) : null}
            <p className="track-duration">{track.duration || "-"}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TrackList;
